var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.96952 4.82681e-06C7.71025 -0.00377677 9.93512 2.21496 9.93892 4.9557C9.94039 6.02543 9.59617 7.067 8.95754 7.92518L11.6402 10.1942C12.071 10.5619 12.1222 11.2091 11.7546 11.6399C11.3869 12.0707 10.7397 12.1219 10.3089 11.7542C10.2679 11.7192 10.2296 11.6809 10.1946 11.6399L7.92496 8.95762C5.72105 10.5911 2.61025 10.1286 0.976837 7.92466C-0.656593 5.72074 -0.194119 2.60995 2.0098 0.976534C2.86606 0.341918 3.90374 -0.000450251 4.96952 1.00648e-05L4.96952 4.82681e-06ZM4.96952 8.89247C7.13621 8.89247 8.89266 7.13602 8.89266 4.96932C8.89266 2.80263 7.13621 1.04618 4.96952 1.04618C2.80282 1.04618 1.04637 2.80263 1.04637 4.96932V4.9693C1.04637 7.13598 2.80281 8.89242 4.96949 8.89244L4.96952 8.89247Z",
    fill: "#B8BEC7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.181ce32f0f5091ac7eddb3e3f1265859.svg";
export { ForwardRef as ReactComponent };